//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
	name: 'GeoTable',
	props: {
		geoType: {
			type: String,
			required: true,
		},
		userType: {
			type: String,
			required: true,
		},
		data: {
			type: Array,
			required: true,
		},
	},

	computed: {
		columns() {
			return [
				{ name: 'name', label: this.geoType, field: 'name', align: 'left', style: 'max-width: 100px' },
				{ name: 'value', label: this.userType, field: 'value' },

			];
		},

	},
};
